import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e21b1f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "text-left"
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-y-1 text-left"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500" }, "Error something wrong", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 2,
  class: "flex items-center justify-center text-gray-400"
}

import { inject, ref } from "vue";
  import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
  import { useStore } from "vuex";
  import { AxiosInstance } from "axios";
  import "dayjs/locale/th";
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'PopOver2',
  props: {
    data: { type: Object, required: true },
    title: { type: String, default: "รายละเอียด" },
    manualValue: [Object, String, Array],
  },
  setup(__props) {

const props = __props

  
  
  const axios = inject("$axios") as AxiosInstance;
  const store = useStore();
  const result = ref<any>(null);
  const isLoading = ref(false);
  const checkData = async () => {
    if (!props.data) return;
  
    isLoading.value = true;
    result.value = null;
    const payload = {
      operatorId: store.state.selectedOperator.operatorId,
      userId: props.data.userId,
      transferId: Number(props.data.id),
    };
    try {
      let type
      if (props.data.transferType === "DEPOSIT") {
      type = "deposit"
      } else if (props.data.transferType === "WITHDRAW") {
      type = "withdraw"
      }
      const { data } = await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/payment/${type}/recheck`,
          payload
        );
      console.log("data: ",data)
      result.value = data.result;
    } catch (err) {
      console.error("❌ Fetch error:", err);
    } finally {
      isLoading.value = false;
    }
  };
  
return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (__props.data.status == 'SUBMITTED')
    ? (_openBlock(), _createBlock(_unref(Popover), {
        key: 0,
        class: "relative w-64"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(PopoverButton), {
            class: "text-white rounded p-1 w-24 bg-blue-400 border-0",
            onClick: checkData,
            disabled: isLoading.value
          }, {
            default: _withCtx(() => [
              (isLoading.value)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    spin: "",
                    class: "text-gray-100 mr-1",
                    transform: "grow-6",
                    icon: ['fas', 'circle-notch']
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(__props.title), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_unref(PopoverPanel), { class: "ring rounded absolute z-10 p-3 bg-white mt-2 w-72 shadow-lg text-sm" }, {
            default: _withCtx(() => [
              (__props.manualValue)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (Array.isArray(__props.manualValue))
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.manualValue, (x) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: x,
                            class: "text-xs text-left"
                          }, _toDisplayString(x), 1))
                        }), 128))
                      : (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.manualValue), 1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!isLoading.value && result.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createElementVNode("p", null, _toDisplayString(result.value), 1)
                        ]))
                      : (!isLoading.value && !result.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_font_awesome_icon, {
                              spin: "",
                              icon: ['fas', 'circle-notch'],
                              class: "mr-1"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.loading")), 1)
                          ]))
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})